<template>
    <!-- 文字类型渲染
         @author: liuguisheng
         @date: 2019-11-25
    -->
  <div v-if="currentFormShow"
       class="render-item_text render-item" 
       :class="[{['full-line']: fullLine},customClass]"
       :style="{ 
         fontSize: fontSize,
         lineHeight: lineHeight,
         width: (align !== 'none') ? '100%' : undefined,
         textAlign: (align !== 'none') ? align : undefined,
       }"><br v-if="wrap"><template v-for="i in indent">&emsp; </template><span :class="{
            italic: italic == 'all',
            strong: strong == 'all',
          }"
          :style="{
            borderBottom: showTextUnderline === 'underline' ? '1px solid #5c5c5c'  : 'none',
            paddingBottom: '2px',
            color: renderColor
          }"><span v-if="underline == 'underline'">&nbsp;</span>{{labelName}}<span v-if="underline == 'underline'">&nbsp;</span><span style="color: transparent; display: contents;word-break: break-all;">{{seat}}</span></span>
  </div>
</template>


<script>
/** 混入方法 ::: 
 *  @mixin mixRenderItemTemplateChild 预览表单子级混入
 */
import { mixRenderItemTemplateChild } from "@/mixins/render_item/mix_render_item_template_child.js";


export default {
  mixins: [ mixRenderItemTemplateChild ],
  computed: {
    /** @name 是否显示当前表单项
     *  @return {Boolean} { true:显示, false:隐藏 } 
     *  @author 王汝鹏
     *  @version 2020-01-04
     */
    currentFormShow() {
      // 1. 表单项配置 显示标记是否为显示
      // 2. 表单项配置 渲染区显示标记是否为显示
      return this.isDisplay
          && this.showRule!=='form';
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/render_item/RenderText.vue